import { useForm } from "react-hook-form";
import * as yup from "yup";

export type CityFormType = {
  id: string;
  istat: string;
  name: string;
  province: string;
  region: string;
  beaches?: string[];
};

const validationSchema = yup.object<CityFormType>().shape({
  id: yup.string(),
  istat: yup.string().required("Campo obbligatorio"),
  name: yup.string().required("Campo obbligatorio"),
  province: yup.string().required("Campo obbligatorio"),
  region: yup.string().required("Campo obbligatorio"),
  beaches: yup.array(yup.string().default([])),
});

const useCityForm = (defaultValues?: CityFormType) => {
  const form = useForm<CityFormType>({ validationSchema, defaultValues });

  return { ...form };
};

export default useCityForm;
